import { useState } from 'react';

export default function useLLMDetails() {
  const [activeTab, setActiveTab] = useState('overview');
  return { activeTab, setActiveTab };
}
